<img
  (click)="logoClicked()"
  alt="Saskatchewan Pension Plan"
  i18n-alt
  [style.height]="height"
  [style.width]="width"
  [src]="logoImage$ | async" />
